
























































import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    pageDataType
} from "../types";
import {
    HOST,
    API_URL
} from "../global";
import {
    pageData
} from "@/store/pageData";
import NewsCard from '../components/NewsCard.vue';
import {
    FETCH_PAGE_BY_ID,
    FETCH_NEWS_DATA
} from "../store/actions.names";

import axios from 'axios';
import {
    TimelineMax,
    TweenLite,
    Power1,
    TweenMax,
    Expo,
    Power2,
    Power3,
    Power4
} from "gsap";
@Component({
    name: "NewsIndexPage",
    components: {
        NewsCard
    }
})

export default class NewsIndexPage extends Vue {
    @Prop() public pageData!: pageDataType;
    @Getter("pageType") public pageType!: string | null;
    @Action(FETCH_NEWS_DATA) fetchNewsData: any;
    public HOST: string = HOST;
    totalPages: number | null = null;
    limit: number = 12;
    //  limit: number = 1;
    currentPage: number = 1;
    newsData: any[] = [];
    // paginationData: any[] = [];
    // public goToPage(url: string) {
    //     this.$router.push(url);
    // }
    //  public paginationData: pageDataType | null = null;
    // @Action(FETCH_PAGE_BY_ID)[FETCH_PAGE_BY_ID]: any;

    public heroimganim(): void {
        const {
            imgoverlay
        } = this.$refs
        TweenLite.delayedCall(1.5, overlay);

        function overlay() {
            TweenMax.to(imgoverlay, .3, {
                opacity: .4,
                ease: Power2.easeOut
            });
        }
        var heroimganim = new TimelineMax({});
        heroimganim
            .to(imgoverlay, .01, {
                opacity: 0,
            })

            .staggerFrom(".banner-wrap img", .8, {
                delay: .2,
                autoAlpha: 0,
                scale: 1.5,
                height: 100,
                y: 600,
                ease: Power2.easeOut,
                clearProps: 'all'
            }, 0.1)
            .to('.banner-text', .01, {
                overflow: 'hidden'
            })
            .staggerFrom('.banner-text h1', .6, {
                autoAlpha: 0,
                y: 80,
                ease: Power1.easeOut,
                clearProps: 'all'
            }, .1, '-=.05')
            .staggerFrom('.banner-text p', .6, {
                autoAlpha: 0,
                y: 80,
                ease: Power1.easeOut,
                clearProps: 'all'
            }, .2, '-=.3')
            .to('.banner-text', .01, {
                clearProps: 'all'
            });

    }

    public fetchNews() {
        if (this.currentPage < 1) {
            this.currentPage = 1
        }
        if (this.totalPages != null && this.currentPage > this.totalPages) {
            this.currentPage = this.totalPages
        }
        const offset = (this.currentPage - 1) * this.limit
        this.fetchNewsData({
                id: this.pageData.id,
                limit: this.limit,
                offset
            })
            .then((data: any) => {
                this.totalPages = Math.ceil(data.meta.total_count / this.limit)
                this.newsData = data.items
            }).catch((err: any) => {
                console.log(err);
            })
    }

    @Watch("currentPage", {
        immediate: true
    })
    handleCurrentPageChage(val: number, oldVal: number) {
        if (val != oldVal) {
            this.fetchNews();
        }
    }

    public mounted() {
        this.heroimganim();
        // this.fetchNews();
    }
    // mounted() {
    //     this[FETCH_PAGE_BY_ID]({
    //         id: (this as any).pageData.id,
    //         fields: "*"
    //     }).then((data: any) => {
    //        this.paginationData = data;

    //     });
    // }
}
